module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_8011.85f15be4.png";